import Header from "./components/Header";
import HeroBanner from "./components/HeroBanner";
import About from "./components/About";
import Products from "./components/Products";
import WhyChooseUs from "./components/WhyChooseUs";
import Certifications from "./components/Certifications";
import Testimonials from "./components/Testimonials";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import FloatingWhatsApp from "./components/FloatingWhatsApp";

export default function Home() {
  return (
    <div className="min-h-screen font-sans overflow-x-hidden">
      <Header />
      <section>
        <HeroBanner />
      </section>
      <section>
        <About />
      </section>
      <section>
        <Products />
      </section>
      <WhyChooseUs />
      <Certifications />
      <section>
        <Testimonials />
      </section>
      <section>
        <Contact />
      </section>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}
